import * as React from 'react'
import * as ReactDOM from 'react-dom'

import Embed from 'embed/Embed'

ReactDOM.render(<Embed />, document.getElementById('root'))
